/**
 * Every route path in the app. Routes are nested by domain, mirroring the
 * screen groups in sgf-customer-mobile (app/screens/*).
 *
 * A path here is a permanent contract: old app versions stay installed on
 * customer devices for a long time and keep opening the path they were built
 * with. Rename only with a redirect left behind.
 */
export const ROUTES = {
  root: "/",
  settings: {
    root: "/settings",
    account: "/settings/account",
    accountInputPin: "/settings/account/input-pin",
    accountDocumentAddress: "/settings/account/document-address",
    accountChangeAddress: "/settings/account/change-address",
    accountChangeAddressConfirm: "/settings/account/change-address-confirm",
    accountChangeAddressSuccess: "/settings/account/change-address-success",
    accountChangeAddressError: "/settings/account/change-address-error",
  },
  dev: {
    login: "/dev/login",
    diagnostics: "/dev/diagnostics",
  },
} as const;
